import { useQuery } from 'react-query';
import HookTypes from '../redux/types/hooks';
import { getZohoUsers } from '../redux/services/userService';

export const useMevosUsers = () => {
  return useQuery([HookTypes.mevosUsers], async () => {
    const response = await getZohoUsers();
    return response;
  });
};
